import { css } from '@/styled-system/css';

export const accordionItemStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: 'Accordion.gap.header-toPanel',
  borderWidth: 'Accordion.default',
  borderStyle: 'solid',
  borderColor: 'Accordion.border.default',
  borderRadius: 'Accordion.default',
});
